module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Visdoctor"
  }, [
    [_c('el-table', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "data": _vm.tableData,
        "border": "",
        "header-cell-style": _vm.tableHeaderColor
      }
    }, [_c('el-table-column', {
      attrs: {
        "label": "时间",
        "width": "auto"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('el-icon', {
            class: {
              backgroundColor: scope.row.emergency == true ? _vm.active : !_vm.active
            },
            attrs: {
              "name": "warning"
            }
          }), _vm._v(" "), _c('span', {
            staticStyle: {
              "margin-left": "10px"
            }
          }, [_vm._v(_vm._s(scope.row.periodOfTime))])]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "预约人",
        "width": "auto"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('div', {
            staticClass: "name-wrapper",
            attrs: {
              "slot": "reference"
            },
            slot: "reference"
          }, [_c('div', [_vm._v(_vm._s(scope.row.patient.name) + "," + _vm._s(scope.row.patient.age) + "," + _vm._s(scope.row.patient.gender) + "\n                        ")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(scope.row.patient.mobileNumber))])])]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "patient.level",
        "label": "会员等级",
        "width": "100"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('el-tag', {
            attrs: {
              "type": scope.row.patient.level === '1' ? 'normal' : (scope.row.patient.level === '2' ? 'warning' :
                (scope.row.patient.level === '3' ? 'danger' : 'success'))
            }
          }, [_vm._v("\n                        " + _vm._s(scope.row.patient.level === '1' ? '普通会员' : (scope.row.patient.level === '2' ? '银卡会员' :
            (scope.row.patient.level === '3' ? '金卡会员' : '铂金会员'))) + "\n                    ")])]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "看诊医生",
        "width": "100"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('div', {
            staticClass: "name-wrapper",
            attrs: {
              "slot": "reference"
            },
            slot: "reference"
          }, [_c('p', {
            staticClass: "phone-s"
          }, [_vm._v(_vm._s(scope.row.doctorName))])])]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      staticStyle: {
        "text-aligin": "left"
      },
      attrs: {
        "label": "状态",
        "width": "auto",
        "prop": "reservationStatus",
        "filters": [{
          text: '候诊',
          value: 1
        }, {
          text: '看诊',
          value: 2
        }, {
          text: '结束看诊',
          value: 3
        }],
        "filter-method": _vm.filterTag,
        "filter-placement": "bottom-end"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('el-tag', {
            attrs: {
              "type": scope.row.reservationStatus == 1 ? 'success' : 'info'
            }
          }, [_vm._v("候诊")]), _vm._v(" "), _c('el-tag', {
            attrs: {
              "type": scope.row.reservationStatus == 2 ? 'success' : 'info'
            }
          }, [_vm._v("看诊")]), _vm._v(" "), _c('el-tag', {
            attrs: {
              "type": scope.row.reservationStatus == 3 ? 'success' : 'info'
            }
          }, [_vm._v("结束看诊")])]
        }
      }])
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "checkInDateTime",
        "label": "签到时间",
        "width": "160"
      }
    }), _vm._v(" "), _c('el-table-column', {
      staticStyle: {
        "text-aligin": "left"
      },
      attrs: {
        "label": "操作",
        "width": "auto"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [(scope.row.reservationStatus != 0) ? _c('el-button', {
            attrs: {
              "disabled": "",
              "type": "primary",
              "icon": "el-icon-edit-outline"
            }
          }, [_vm._v("已签到\n                    ")]) : _c('el-button', {
            attrs: {
              "type": "primary",
              "icon": "el-icon-edit-outline"
            },
            on: {
              "click": function($event) {
                $event.stopPropagation();
                return _vm.signIn(scope.$index, _vm.tableData)
              }
            }
          }, [_vm._v("签到\n                    ")])]
        }
      }])
    })], 1)]
  ], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b01a9e7c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/reservation/Visdoctor.vue
// module id = 1042
// module chunks = 2